"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_my__vodafone__or__my__profile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "8a4284d1-f8f8-488e-951f-8c3d505b266d",
    "data-name": "My_Vodafone_or_profile_ic_mid",
    viewBox: "0 0 192 192"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "91d1bdcb-384f-4df2-8408-cb5f4a7629e4",
    "data-name": "<Pfad>",
    cx: 96,
    cy: 62,
    r: 36,
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "85596dc8-aef1-4cd7-ae3e-3bbcc86b67bf",
    "data-name": "<Pfad>",
    d: "M154,166c-6.48-43.73-31.53-68-58-68s-51.51,24.27-58,68",
    fill: "none",
    stroke: "#676767",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("title", null, "my-vodafone-mid"), /*#__PURE__*/React.createElement("g", {
    id: "f30505c3-9665-45cc-9f32-cb911363b953",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("use", {
    id: "02d2c87d-eee1-42aa-96f4-6763ff3565f8",
    "data-name": "My_Vodafone_or_profile_ic_mid",
    width: 192,
    height: 192,
    transform: "translate(0 0)",
    xlinkHref: "#8a4284d1-f8f8-488e-951f-8c3d505b266d"
  })));
}

var _default = ic_my__vodafone__or__my__profile;
exports.default = _default;